import { DeliverabilityRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/analysis/deliverability')({
  component: DeliverabilityRoute,
});
